/* It's a React component. */
import React from "react"
import { FormControl, OverlayTrigger, Tooltip } from "react-bootstrap"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
//@ts-ignore
import uuid from "react-uuid"
import "./CustomDropdownConfig.css"

interface Props {
    manageGranparentState: Function
    target: { row: number, col: number }
    template: Array<Array<FieldTypes>> | []
    hints: boolean
}

function CustomDropdownConfig(props: Props) {

    const row = props.target.row
    const col = props.target.col
    const template = props.template
    const useCustomDropdownConfigItems = template[row][col].CustomDropDown

    /**
     * `buildWithIds` takes an array of strings and returns an array of objects with an id and text
     * property.
     * @param items - Array<string | null>
     * @returns An array of objects with an id and text property.
     */
    const buildWithIds = (items: Array<string | null>) => {
        let arr = []
        for (let i = 0; i < items.length; i++) {
            arr.push({ id: uuid(), text: items[i] })
        }
        return arr
    }

    /**
     * `stripIds` takes an array of objects with `id` and `text` properties and returns an array of `text`
     * values
     * @param items - Array<{ id: string, text: string | null }>
     * @returns An array of strings.
     */
    const stripIds = (items: Array<{ id: string, text: string | null }>) => {
        let arr = []
        for (let i = 0; i < items.length; i++) {
            arr.push(items[i].text)
        }
        return arr
    }

    const items = buildWithIds(props.template[row][col].CustomValues || [])

    /**
     * "If an item is passed in, remove it from the items array, otherwise add a new item to the items
     * array."
     * @param [item] - the item that was selected from the dropdown
     * @returns the function addOrRemoveItem.
     */
    const addOrRemoveItem = (item?: { id: string, text: string }) => {
        const row = props.target.row
        const col = props.target.col
        let temp = items
        let template = props.template
        if (item) {
            temp = temp.filter(function (obj) { return obj.id !== item.id })
        }
        else {
            items.push({ id: uuid(), text: null })
        }
        template[row][col].CustomValues = stripIds(temp)
        props.manageGranparentState([{ key: "template", value: template }])
    }

    const CustomDropdownConfigTooltip = (text: string, overrideHints?: boolean) => (
        <Tooltip id={`dynamic-form-tool-tip-hide-${!props.hints && !overrideHints}`}>
            {text}
        </Tooltip>
    )

    return (
        <div className="CustomDropdownConfig">
            {template[row][col].CustomDropDown && <div className="CustomDropdownConfigItems">
                {items.map((item, i: number) =>
                    <div className="CustomDropdownConfigItem" key={`custom-dropdown-config-item-${i}`}>
                        <p>{i + 1}.</p>
                        <FormControl
                            placeholder={"Empty"}
                            //@ts-ignore
                            value={item.text || ""}
                            onChange={(e) => {
                                const input = e.target.value
                                const row = props.target.row
                                const col = props.target.col
                                let temp = props.template
                                //@ts-ignore
                                temp[row][col].CustomValues[i] = input
                                props.manageGranparentState([{ key: "template", value: temp }])
                            }}
                        />
                        {/*@ts-ignore*/}
                        <TrashCan clickCallback={() => addOrRemoveItem(item)} color="#00000050" />
                    </div>
                )}
            </div>}
            <div className="CustomDropdownConfigToggle">
                <div className="CustomDropdownConfigToggleLeft">
                    <p>Custom?</p>
                    <FormControl
                        id={"custom-dropdown-config-toggle-checkbox"}
                        checked={useCustomDropdownConfigItems}
                        onChange={() => {
                            const row = props.target.row
                            const col = props.target.col
                            let template = props.template
                            template[row][col].CustomValues = []
                            template[row][col].ReferenceName = null
                            template[row][col].CustomDropDown = !template[row][col].CustomDropDown
                            props.manageGranparentState([{ key: "template", value: template }])
                        }}
                        type="checkbox"
                    />
                </div>
                <OverlayTrigger placement="left" overlay={CustomDropdownConfigTooltip("Add item")}>
                <div className="CustomDropdownConfigToggleRight">
                    {useCustomDropdownConfigItems && <div className="AddCustomDropdownConfigItem">
                        <span className="material-icons" onClick={() => addOrRemoveItem()}>add</span>
                    </div>}
                </div>
                </OverlayTrigger>
            </div>
        </div>
    )
}

export default CustomDropdownConfig